<template>
  <div>
    <el-card>
      <div>
        请输入内场雕像,0代表圆形,3代表三角形,4代表正方形
      </div>
      <el-row type="flex">
        <el-col>
          <el-input ref="innerStatue" v-model="innerStatue" class="statue-input" placeholder="内场雕像" maxlength="3" clearable @input="handleInnerStatue" />
          <span v-if="illegalInput">你认真的?</span>
        </el-col>
      </el-row>
      <el-row type="flex" justify="space-around">
        <el-col :span="7">
          <statue-icon :statue="leftStatue" />
        </el-col>
        <el-col :span="7">
          <statue-icon :statue="middleStatue" />
        </el-col>
        <el-col :span="7">
          <statue-icon :statue="rightStatue" />
        </el-col>
      </el-row>
      <div>
        墙上的初始图案
      </div>
      <el-row type="flex" justify="space-around">
        <el-col :span="7">
          <!--          <el-input ref="leftWall" v-model="leftStatue" class="statue-input" placeholder="左" maxlength="1" @input="checkStatue($event,'middleStatue')" @focus="focusInput('leftStatue')" />-->
          <statue-icon statue="4" />
          <statue-icon statue="4" />
        </el-col>
        <el-col :span="7">
          <!--          <el-input ref="leftWall" v-model="leftStatue" class="statue-input" placeholder="左" maxlength="1" @input="checkStatue($event,'middleStatue')" @focus="focusInput('leftStatue')" />-->
          <statue-icon statue="4" />
          <statue-icon statue="4" />
        </el-col>
        <el-col :span="7">
          <!--          <el-input ref="leftWall" v-model="leftStatue" class="statue-input" placeholder="左" maxlength="1" @input="checkStatue($event,'middleStatue')" @focus="focusInput('leftStatue')" />-->
          <statue-icon statue="4" />
          <statue-icon statue="4" />
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import StatueIcon from '@/view/d2/conponents/statue-icon/index.vue'
export default {
  name: 'ReportImg',
  components: { StatueIcon },
  props: {
  },
  data() {
    return {
      innerStatue: '',
      leftStatue: undefined,
      middleStatue: undefined,
      rightStatue: undefined,
      illegalInput: false
    }
  },
  methods: {
    handleInnerStatue(value) {
      console.log('1111111', value)
      if (value.length === 3) {
        this.leftStatue = value[0]
        this.middleStatue = value[1]
        this.rightStatue = value[2]
      }
    },
    focusInput(ref) {
      this.$refs[ref].select()
      this.$refs[ref].reset()
    }
  }
}
</script>

<style scoped>
.statue-input {
  width: 200px;
}
</style>
